import React, { useRef, useState, useEffect } from "react";

function RuImageInput({
  onChange,
  label = "Upload Image",
  previewSize = 150,
  value = null, // ← existing image URL or null
}) {
  const [preview, setPreview] = useState(value);
  const inputRef = useRef(null);

  // when value changes (e.g., during edit form initialization), update preview
  useEffect(() => {
    setPreview(value);
  }, [value]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);

    if (onChange) onChange(file);
  };

  const handleClear = () => {
    setPreview(null);
    if (inputRef.current) inputRef.current.value = "";
    if (onChange) onChange(null);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      <label
        style={{
          display: "inline-block",
          cursor: "pointer",
          backgroundColor: "#007bff",
          color: "white",
          padding: "0.5rem 1rem",
          borderRadius: "4px",
          textAlign: "center",
          width: "fit-content",
        }}
      >
        {label}
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: "none" }}
        />
      </label>

      {preview && (
        <div
          style={{
            position: "relative",
            width: previewSize,
            height: previewSize,
          }}
        >
          <img
            src={preview}
            alt="preview"
            style={{
              width: previewSize,
              height: previewSize,
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #ccc",
            }}
          />
          <button
            onClick={handleClear}
            type="button"
            style={{
              position: "absolute",
              top: 4,
              right: 4,
              background: "rgba(0,0,0,0.6)",
              color: "white",
              border: "none",
              borderRadius: "50%",
              width: 24,
              height: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}

export default RuImageInput;
